import {
  WEBSOCKET_CONNECT,
  WEBSOCKET_OPEN,
  WEBSOCKET_DISCONNECT,
  WEBSOCKET_CLOSED,
  WEBSOCKET_BEGIN_RECONNECT,
  WEBSOCKET_RECONNECTED,
  WEBSOCKET_BROKEN,
  WEBSOCKET_ERROR,
} from "@giantmachines/redux-websocket";
import { isSocketPrefix } from "../../socket/socketPrefix";

const initialSocketConfig = {
  stateChanged: false,
  connecting: false,
  connected: false,
  disconnecting: false,
  disconnected: false,
  reconnecting: false,
  reconnected: false,
  error: false,
};

/**
 * The sockets will be added dynamically, each socket will have @{initialSocketConfig} object, ex:
 *
 * SOME_PREFIX: {
 *   stateChanged: false,
 *   connecting: false,
 *   connected: false,
 *   disconnecting: false,
 *   disconnected: false,
 *   reconnecting: false,
 *   reconnected: false,
 *   error: false,
 * }
 */
const initialState = {};

const splitAction = (type) => {
  const splits = type.split("::");
  return {
    prefix: splits[0],
    socketAction: splits[1],
  };
};

const updateSocketStateChanged = (state, changed) => {
  if (state.stateChanged != undefined)
    return {
      ...state,
      stateChanged: changed,
    };
  return state;
};

const consumeNonSocketState = (state) => {
  // Iterate over state
  Object.entries(state).forEach((e) => {
    if (e[1].stateChanged != undefined)
      // Check if the state is a socket state
      e[1].stateChanged = false; // Make the `stateChanged` to false
  });

  return { ...state };
};

export const socketReducer = (state = initialState, action) => {
  const { prefix, socketAction } = splitAction(action.type);

  // Handle library actions.
  if (prefix && isSocketPrefix(prefix)) {
    return {
      ...state,
      [`${prefix}`]: {
        ...consumeSocketActions(state[prefix], socketAction),
      },
    };
  }

  return consumeNonSocketState(state);
};

const consumeSocketActions = (state, socketAction) => {
  switch (socketAction) {
    case WEBSOCKET_CONNECT:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        connecting: true,
      };
    case WEBSOCKET_OPEN:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        connected: true,
      };
    case WEBSOCKET_DISCONNECT:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        disconnecting: true,
      };
    case WEBSOCKET_CLOSED:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        disconnected: true,
      };
    case WEBSOCKET_BEGIN_RECONNECT:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        reconnecting: true,
      };
    case WEBSOCKET_RECONNECTED:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        reconnected: true,
      };
    case WEBSOCKET_BROKEN:
    case WEBSOCKET_ERROR:
      return {
        ...initialSocketConfig,
        stateChanged: true,
        error: true,
      };
    default:
      return updateSocketStateChanged(state, false);
  }
};

export default socketReducer;
